import Fetch from "../script/Fetch";
import { Carrello } from "orser-model/Carrello";

export default class CarrelloService {
    async sendCarrello(clienteId: string, carrello: Carrello) {
        try {
            const response = await Fetch.doFetch(`/cliente/${clienteId}/ordine`, {
                method: "POST",
                body: carrello
            });
            await response.json();
        } catch (error: any) {
            console.error('Errore durante l\'invio del carrello:', error.message);
        }
    }
}